import React, { useState } from 'react';
import {
  BackgroundContainer,
  Container,
  DesktopSideNav,
  UserFormContainer,
  Loader,
} from '@app/modules/user-roles/user-roles-component';
import UserRolesSidenav from '@app/modules/user-roles/user-roles-sidenav';
import { useGetUserRoles, useGetRolePermissions } from '@app/graphql';
import UserRoleForm from '@app/modules/user-roles/user-role-form';
import { Icon } from '@app/components';
import { SelectedRoleProps, UserTypes } from '@app/types';
import DefaultErroPage from '@app/components/error-pages/default-error-page';

const UserRoles = () => {
  const { loading, data } = useGetUserRoles();
  const [showUserForm, setShowUserForm] = useState(
    window.innerWidth >= 768 ? true : false,
  );
  const [showErrorPage, SetShowErrorPage] = useState(false);
  const [selectedRole, setSelectedRole] = useState<SelectedRoleProps>({
    id: '',
    name: '',
  });
  const [isAdd, setIsAdd] = useState(false);
  const [getUserRoleData] = useGetRolePermissions();
  const [userRoles, setUserRoles] = useState<UserTypes[]>();
  const [userRoleData, setUserRoleData] = useState({});
  const [roleDataloading, setRoleDataLoading] = useState(true);
  const [showSideNav, setShowSideNav] = useState(true);
  const [isMobile, setIsMobile] = useState(
    window.innerWidth < 768 ? true : false,
  );
  window.addEventListener('resize', function() {
    if (window.innerWidth < 768) {
      setShowUserForm(false);
      setIsMobile(true);
      setShowSideNav(true);
    } else {
      setIsMobile(false);
      setShowUserForm(true);
    }
  });
  React.useEffect(() => {
    if (
      !loading &&
      data &&
      data.getAllUserRoles &&
      data.getAllUserRoles.success
    ) {
      const { userRoles } = data.getAllUserRoles;
      setUserRoles(
        userRoles && userRoles.length
          ? userRoles.map((userRole: any) => {
              return { ...userRole, label: userRole.name, value: userRole._id };
            })
          : [],
      );
      if (userRoles && userRoles.length) {
        setSelectedRole({ id: userRoles[0]._id, name: userRoles[0].name });
      }
    }
  }, [loading, data]);

  React.useEffect(() => {
    if (selectedRole && selectedRole.id) {
      setRoleDataLoading(true);
      getUserRoleData({ variables: { roleId: selectedRole.id } })
        .then((response: any) => {
          if (
            response &&
            response.data.getRolePermissions &&
            response.data.getRolePermissions.success
          ) {
            const { rolePermissions } = response.data.getRolePermissions;
            setUserRoleData(rolePermissions);
          }
          setRoleDataLoading(false);
        })
        .catch((error: any) => {
          SetShowErrorPage(true);
        });
    }
    //eslint-disable-next-line
  }, [selectedRole]);

  const addUserRole = () => {
    setUserRoleData([]);
    setRoleDataLoading(true);
    setSelectedRole({ id: '', name: '' });
    setIsAdd(true);
    setTimeout(() => {
      setRoleDataLoading(false);
    }, 500);
  };

  const onCancel = () => {
    setShowUserForm(false);
    setShowSideNav(true);
  };
  const updateSelectedRole = (role: SelectedRoleProps) => {
    setSelectedRole(role);
    setIsAdd(false);
    if (isMobile) {
      setShowSideNav(false);
      setShowUserForm(true);
    }
  };
  const updateRoles = (newRole: any) => {
    if (newRole) {
      const UserRole: any = userRoles;
      setUserRoles(UserRole.concat(newRole));
    }
  };
  return (
    <>
      {showErrorPage ? (
        <DefaultErroPage />
      ) : (
        <BackgroundContainer>
          <Container>
            <DesktopSideNav>
              {loading ? (
                <Loader>
                  <Icon name="loader" />
                </Loader>
              ) : showSideNav ? (
                <UserRolesSidenav
                  userRoles={userRoles}
                  addUserRole={addUserRole}
                  setSelectedRole={updateSelectedRole}
                  selectedRole={selectedRole}
                  isMobile={isMobile}
                />
              ) : null}
            </DesktopSideNav>
            {showUserForm ? (
              <UserFormContainer>
                <UserRoleForm
                  selectedRole={selectedRole}
                  onCancel={onCancel}
                  userRoleData={userRoleData}
                  loading={roleDataloading}
                  isAdd={isAdd}
                  userRoles={userRoles}
                  setSelectedRole={updateSelectedRole}
                  setUserRoles={updateRoles}
                />
              </UserFormContainer>
            ) : null}
          </Container>
        </BackgroundContainer>
      )}
    </>
  );
};

export default UserRoles;
